/* Format percentage */
export default (value) => {
     return parseInt(value) + '%';
}


// WEBPACK FOOTER //
// ./src/filters/formatPercentage.js